import { useCallback } from "react"
import { useMutation } from "react-relay"
import { graphql, PayloadError } from "relay-runtime"
import {
  ImportCsvCapacityPlanInput,
  useImportCsvCapacityPlanMutation as useImportCsvCapacityPlanMutationType,
  useImportCsvCapacityPlanMutation$data,
} from "@/modules/admin/capacity/services/__generated__/useImportCsvCapacityPlanMutation.graphql"

const mutation = graphql`
  mutation useImportCsvCapacityPlanMutation($input: ImportCsvCapacityPlanInput!) {
    importCsvCapacityPlan(input: $input) {
      importCsvCapacityPlanResult {
        importedRows
        forecastFileUpload {
          uploadBy
          uploadAt
        }
      }
      errors {
        __typename
        ... on DataFormatNotSupported {
          message
          errorMessage
        }
        ... on Error {
          message
        }
      }
    }
  }
`

export function useImportCsvCapacityPlanMutation(): [
  (
    input: ImportCsvCapacityPlanInput,
    handleComplete?:
      | ((response: useImportCsvCapacityPlanMutation$data, errors: PayloadError[] | null) => void)
      | undefined,
    handleError?: ((error: Error) => void) | undefined,
  ) => void,
  boolean,
] {
  const [commit, areMutationsInFlight] = useMutation<useImportCsvCapacityPlanMutationType>(mutation)

  return [
    useCallback(
      (
        input: ImportCsvCapacityPlanInput,
        handleComplete?: (response: useImportCsvCapacityPlanMutation$data, errors: PayloadError[] | null) => void,
        handleError?: (error: Error) => void,
      ) => {
        commit({
          variables: {
            input: {
              file: input.file,
            },
          },
          onCompleted: handleComplete,
          onError: handleError,
        })
      },
      [commit],
    ),

    areMutationsInFlight,
  ]
}
